import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { GoogleMapsModule } from '@angular/google-maps';
import { NgProgressModule } from 'ngx-progressbar';
import { NgProgressHttpModule } from 'ngx-progressbar/http';
import { InputFileConfig, InputFileModule } from './theme/components/input-file/input-file.module';
const config: InputFileConfig = {
  fileAccept: '*'
};

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, environment.fileServiceUrl + '/i18n/', '.json');
}

import { Overlay, OverlayContainer } from '@angular/cdk/overlay';
import { FormsModule } from '@angular/forms';
import { MAT_AUTOCOMPLETE_DEFAULT_OPTIONS, MAT_AUTOCOMPLETE_SCROLL_STRATEGY } from '@angular/material/autocomplete';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AppRoutingModule } from './app.routing';
import { AppSettings } from './app.settings';
import { AppComponent } from './components/app/app.component';
import { CookiePolicyComponent } from './components/cookie-policy/cookie-policy.component';
import { NotFoundModule } from './components/pages/not-found/NotFoundModule';
import { PageContainerSimpleComponent } from './components/pages/page-container-simple/page-container-simple.component';
import { PageContainerComponent } from './components/pages/page-container/page-container.component';
import { DialogPdf } from './dialogs/dialog-pdf/dialog-pdf';
import { SharedModule } from './shared/shared.module';
import { ContactsComponent } from './theme/components/contacts/contacts.component';
import { CurrencyComponent } from './theme/components/currency/currency.component';
import { FooterComponent } from './theme/components/footer/footer.component';
import { HorizontalMenuComponent } from './theme/components/menu/horizontal-menu/horizontal-menu.component';
import { VerticalMenuComponent } from './theme/components/menu/vertical-menu/vertical-menu.component';
import { SocialIconsComponent } from './theme/components/social-icons/social-icons.component';
import { Toolbar1Component } from './theme/components/toolbar1/toolbar1.component';
import { Toolbar2Component } from './theme/components/toolbar2/toolbar2.component';
import { UserMenuComponent } from './theme/components/user-menu/user-menu.component';
import { AppInterceptor } from './theme/utils/app-interceptor';
import { CustomOverlayContainer } from './theme/utils/custom-overlay-container';

@NgModule({
  declarations: [
    AppComponent,
    PageContainerComponent,
    PageContainerSimpleComponent,
    UserMenuComponent,
    CurrencyComponent,
    SocialIconsComponent,
    ContactsComponent,
    Toolbar1Component,
    Toolbar2Component,
    HorizontalMenuComponent,
    VerticalMenuComponent,
    FooterComponent,
    CookiePolicyComponent,
    DialogPdf
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    FormsModule,
    NotFoundModule,
    HttpClientModule,
    GoogleMapsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgProgressModule,
    NgProgressHttpModule,
    InputFileModule.forRoot(config),
    AppRoutingModule,
    NgxChartsModule,
    SharedModule
  ],
  providers: [
    AppSettings,
    { provide: OverlayContainer, useClass: CustomOverlayContainer },
    { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
    // Disables mat-tooltip in mobile
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: { touchGestures: 'off' },
    },
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useFactory: createPropertyAutocompleteBlockScrollStrategy,
      deps: [Overlay],
    },
    {
      provide: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,
      useValue: { overlayPanelClass: 'property-autocomplete-panel' },
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function createPropertyAutocompleteBlockScrollStrategy(overlay: Overlay) {
  return () => overlay.scrollStrategies.block();
}

